import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';

import { FGT_REDIRECT_BASE } from '../../constants';

const sx = {
    root: { overflow: 'hidden' },
    checklistContainer: { padding: '5px' },
    logo: { aspectRatio: '21 / 9' },
    logoImage: { maxHeight: '80px', maxWidth: '100%', objectFit: 'contain' },
    item: { display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingBottom: '9px', fontSize: '9px', lineHeight: '9px' },
    box: { minHeight: '13px', height: '13px', minWidth: '13px', width: '13px', border: '1px solid black', marginRight: '5px' },
    qr: { width: '95%' },
    text: { fontSize: '9px', lineHeight: '9px', fontWeight: '600' },
};

const JobSheetLabelSideForm = ({ checklist = {}, part = {}, hashId = '', qrDisabled = false }) => {
    const { logo, items } = checklist;

    return (
        <div style={sx.root}>
            <div style={sx.checklistContainer}>
                {logo && (
                    <div style={sx.logo}>
                        <img style={sx.logoImage} src={logo} alt={'logo'} />
                    </div>
                )}

                {!qrDisabled && (
                    <div style={sx.qr}>
                        <QRCode size={70} value={`${FGT_REDIRECT_BASE}/${hashId}/${part?.id}`} />
                    </div>
                )}

                {items &&
                    items.map((item) => (
                        <div key={item} style={sx.item}>
                            <div style={sx.box} />
                            <div>
                                <div style={sx.text}>{item}</div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

JobSheetLabelSideForm.propTypes = {
    checklist: PropTypes.shape({
        logo: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.string),
    }),
    part: PropTypes.shape({
        job_id: PropTypes.string,
    }),
    hashId: PropTypes.string,
    qrDisabled: PropTypes.bool,
};

export default JobSheetLabelSideForm;
